import React from "react";

const EvaluationDetails = () => {
  return (
    <div>
      <h1 className="text-2xl font-Outfit  font-semibold text-black mb-8">
        Performance Evaluation
      </h1>

      <div className=" min-h-screen p-4 bg-white ">
        <p>Evaluation Details</p>
      </div>
    </div>
  );
};

export default EvaluationDetails;
